"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const imageCSS = (ratio) => (0, react_1.css) `
    max-width: 100%;
    ${ratio && ratio !== "none"
    ? `
    aspect-ratio: ${ratio};
    object-fit: cover;
    width: 100%;
  `
    : ""}
`;
const Image = (_a) => {
    var { src, alt, aspectRatio } = _a, rest = __rest(_a, ["src", "alt", "aspectRatio"]);
    return (0, jsx_runtime_1.jsx)("img", Object.assign({ src: src, alt: alt, css: imageCSS(aspectRatio) }, rest));
};
exports.Image = Image;
//# sourceMappingURL=image.js.map